



































































































import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";

import {CmsAnchorDto, CmsAnchorDtoPagedResultDto, QuestionType} from "@/api/appService";
import PagedTableView from "@/components/PagedTableView/index.vue";
import EditLink from "@/views/exam/edit.vue";
import ImportExcel from "@/components/ImportExcel/index.vue";

@Component({
  name: "AnchorList",
  components: {
    EditLink,
    PagedTableView,
    ImportExcel
  },
})
export default class AnchorList extends Vue {
  queryForm = {
    question: "",
    questionType:undefined
  };

  questionTypeList=[
    {name:'单选',value:QuestionType.Radio},
    {name:'多选',value:QuestionType.CheckBox},
    {name:'判断',value:QuestionType.YesOrNo},
    {name:'问答',value:QuestionType.QuestionAndAnswer}];

  editLinkId = 0;

  // 获取表数据
  fetchData(params: any) {
    return api.examQuestion.getAll(params);
  }

  // 新建
  handleCreate() {
    this.editLinkId = 0;
    (this.$refs.editForm as any).show = true;
  }

  // 编辑
  handleEdit(index: number, row: any) {
    this.editLinkId = row.id!;
    (this.$refs.editForm as any).show = true;
    (this.$refs.editForm as any).form = row;

    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }

  // 删除
  async handleDelete(index: number, row: any) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.examQuestion
        .delete({
          id: row.id,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

  handelOnSaved() {
    this.fetchData(this.queryForm);
  }
}
